import { ReducerState } from "./../reducers/index";

/**
 * Permet de récupérer le context sélectionné
 * @param state state redux
 */
export const getCurrentContext = (state: ReducerState) =>
  state.context.selected ? state.context.selected : null;

/**
 * Permet de récupérer le premier context présent dans les différents contextes disponibles
 * @param state state redux
 */
export const getFirstContext = (state: ReducerState) =>
  state.context.contexts.length > 0 ? state.context.contexts[0] : null;

/**
 * Permet de récupérer les contexts disponibles
 * @param state state redux
 */
export const getContexts = (state: ReducerState) => state.context.contexts;

/**
 * Permet de récupérer l'objet lié au statechart.
 * @param state state redux
 */
export const selectScenario = (state: ReducerState) => state.scenario;
